import { request } from './request';

export async function agentCreateJob(data: any): Promise<any> {
  return request('POST', `/convert/agents/${data.agentName}/jobs`, {
    json: data,
    body: JSON.stringify(data),
  });
}
